'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default ['$scope', '$uibModalInstance', 'maintenance', 'edit', 'partialEdit', 'project', 'OrgService', 'StaffService', 'projectMaintenances', '$log', 'showPartial', 'cancelPartial', 'editingPartial', 'savePartial', 'ModalService',
                function($scope, $modalInstance, maintenance, edit, partialEdit, project, OrgService, StaffService, projectMaintenances, $log, showPartial, cancelPartial, editingPartial, savePartial, ModalService) {
                    $log.debug('MAINTENANCE-FORM: OPEN');

                    $scope.ok = ok;
                    $scope.cancel = cancel;

                    let oldMaintenance = null;

                    init();

                    // region Function

                    function init() {
                        $log.debug('MAINTENANCE-FORM: INIT');
                        $log.debug('MAINTENANCE-FORM:MAINTENANCE: ', maintenance);

                        $scope.responsibleFilters = [];
                        $scope.dateFormat = 'dd.MM.yyyy';
                        $scope.edit = edit;
                        $scope.partialEdit = partialEdit;
                        $scope.showPartial = showPartial;
                        $scope.cancelPartial = () => {
                            $scope.partialEdit = false;
                            cancel();
                            cancelPartial();
                        };
                        $scope.editingPartial = () => {
                            $scope.partialEdit = true;
                        };
                        $scope.savePartial = () => {
                            $scope.partialEdit = false;
                            ok();
                        }
                        $scope.project = project;
                        $scope.filterIds = extractIds(project);
                        oldMaintenance = angular.copy(maintenance);
                        $scope.maintenance = angular.copy(maintenance);
                        $scope.create = false;
                        $scope.groups = [];
                        let max_npp = 1;
                        let groups = [];

                        if (Array.isArray(projectMaintenances)) {
                            groups = angular.copy(projectMaintenances.filter((it_maintenance) => it_maintenance.isGroup == true));
                            max_npp = getMaxNpp(projectMaintenances.filter((it_maintenance) => it_maintenance.parent == null));
                            ++max_npp;
                        }
                        $scope.groups = groups;
                        $scope.isValidResponsibilities = isValidResponsibilities;
                        // Определение заголовка модального окна
                        if (maintenance != null && maintenance.activityName != null) {
                            $log.debug('MAINTENANCE-FORM:MODE: EDIT');

                            $scope.title = 'Редактирование мероприятия';
                            $scope.create = false;
                        } else {
                            $log.debug('MAINTENANCE-FORM:MODE: CREATE');

                            $scope.title = 'Создание нового мероприятия';
                            $scope.create = true;

                            if (maintenance) {
                                $scope.maintenance.isGroup = false;
                                $scope.maintenance.npp = max_npp;
                                $scope.maintenance.parent = undefined;
                                $scope.maintenance.responsibilities = [];
                            } else {
                                $scope.maintenance = {
                                    isGroup: false,
                                    npp: max_npp,
                                    parent: undefined,
                                    responsibilities: [],
                                };
                            }
                        }
                    }

                    function extractIds (proj) {
                        const checkExist = (human) => {
                            if (!human) return null;
                            return human.org ? human.org.id : human.id
                        }
                        const ids = [];
                        [
                            proj.author,
                            proj.manager,
                            proj.oiv,
                            proj.curatorOiv,
                            proj.coordorg,
                            proj.coordinator,
                            proj.municipalityOrg,
                            proj.municipalityStaff,
                            ...project.projectContacts
                        ].forEach(human => {
                            const org = checkExist(human);
                            if (typeof org === 'number') {
                                const currentOrgIndex = ids.findIndex(item => item .org === org);
                                if (currentOrgIndex === -1) {
                                    ids.push({
                                        org: org,
                                        staff: [human.id],
                                    })
                                } else {
                                    ids[currentOrgIndex].staff.push(human.id);
                                }
                            }
                        });
                        return ids;
                        // project.curatorsMizip
                        // project.projectContacts
                    }

                    function isValidResponsibilities() {
                        if (Array.isArray($scope.maintenance.responsibilities) && $scope.maintenance.responsibilities.length) {
                            return $scope.maintenance.responsibilities.every((responsibility) => {
                                return responsibility.responsibleOrg && responsibility.responsibleStaff;
                            });
                        }
                        return true;
                    }

                    function ok() {
                        $log.debug('MAINTENANCE-FORM:CLOSE: MAINTENANCE: ', $scope.maintenance);
                        if ($scope.isValidResponsibilities()) {
                            $modalInstance.close($scope.maintenance);
                            return;
                        }
                        ModalService.warning({
                            message: 'Не указан ответственный от организации. Продолжить?',
                            apply: 'Да',
                            cancel: 'Отмена',
                        })
                        .result
                        .then(function () {
                            $modalInstance.close($scope.maintenance);
                        });             
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    function getMaxNpp(items) {
                        let max_npp = 0;
                        if (Array.isArray(items)) {
                            items.forEach((it_maintenance) => {
                                max_npp = Math.max(max_npp, it_maintenance.npp);
                            });
                        }
                        max_npp++;
                        return max_npp;
                    }

                    // endregion

                    // region Watcher

                    $scope.$watch('maintenance.responsibleOrg', function(nw, old) {
                        if (nw) {
                            $scope.responsibleFilters = ['\'org.id\' EQ \'' + nw.id + '\''];
                        } else {
                            $scope.responsibleFilters = [];
                        }
                        if ((nw == null) || (old != null && old.id != nw.id)) {
                            angular.copy({}, $scope.maintenance.responsible);
                        }
                    });

                    $scope.$watch('maintenance.parent', function(nw, old) {
                        if (nw) {
                            $scope.maintenance.parentIndex = nw.index;
                            $scope.maintenance.npp = getMaxNpp(projectMaintenances.filter((it_maintenance) => it_maintenance.parentIndex == nw.index));
                            if (oldMaintenance != null && nw.index == oldMaintenance.parentIndex) {
                                $scope.maintenance.npp = oldMaintenance.npp;
                            }
                        } else {
                            $scope.maintenance.parentIndex = null;
                            $scope.maintenance.npp = getMaxNpp(projectMaintenances.filter((it_maintenance) => it_maintenance.parent == null));
                            if (oldMaintenance != null && oldMaintenance.parentIndex == null && oldMaintenance.npp != null) {
                                $scope.maintenance.npp = oldMaintenance.npp;
                            }
                        }
                    });

                    // endregion
                }];
